import React from "react";
import { useRouteData } from "react-static";

import PlaceNavigation from "@components/PlaceNavigation";
import useBodyClass from "@utils/useBodyClass";
import Layout from "../components/Layout";

/**
 * Il m'est venu à l'idée qu'il était possible d'avoir l'affichage que l'on désire
 * Totalement en CSS sans avoir besoin de modifier le composant
 * Liste Navigation
 */
export default () => {
  const { places } = useRouteData();
  useBodyClass("place-list", "");

  return (
    <Layout includeFooter includeHeader recordLocation>
      <div className="containerCarte" id="maincontent" tabIndex={-1}>
        <PlaceNavigation type="place" items={places} />
      </div>
    </Layout>
  );
};
